import React from 'react'

import Header from './Header'
import MenuBar from '../components/MenuBar'

const Home = () => {
    return (
        <React.Fragment>
            <MenuBar />
            <Header />

        </React.Fragment>
    )
}

export default Home;
